import { render, staticRenderFns } from "./PopulateIdentityNumbers.vue?vue&type=template&id=6a7fec21"
import script from "./PopulateIdentityNumbers.vue?vue&type=script&lang=js"
export * from "./PopulateIdentityNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports